<template>
    <sa-page-layout :showModalLoading="showModalLoading" :btnBackVisible="true" :linkback="linkback">
        <template slot="table-filter">
            <rsa-configurazione-posti-letto-letti-view-component ref="cmpRsaConfigurazionePostiLettoLettiView" />
        </template>
        <template slot="table-body">
            <rsa-gestione-camere-storico-list-component ref="cmpGestioneCamereStoricoList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
        </template>
        <template slot="table-footer"> </template>
    </sa-page-layout>
</template>

<script>
import RsaGestioneCamereStoricoListComponent from "../components/RsaGestioneCamereStoricoListComponent.vue";
import RsaConfigurazionePostiLettoLettiViewComponent from "../../rsaconfigurazione/components/RsaConfigurazionePostiLettoLettiViewComponent.vue";
// import RsaGestioneCamereListComponent from "../components/RsaGestioneCamereListComponent.vue";
// import RsaStoricoLettiListComponent from "../components/RsaStoricoLettiListComponent.vue";
import saPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: { saPageLayout, RsaGestioneCamereStoricoListComponent, RsaConfigurazionePostiLettoLettiViewComponent },
    mixins: { UtilityMixin },
    data() {
        return {
            showModalLoading: false,
            idLetto: null,
            linkback: "/rsagestionecamere",
        };
    },

    mounted() {
        let me = this;
        me.idLetto = this.$route.params.id;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpRsaConfigurazionePostiLettoLettiView.loadData(me.idLetto);
            me.$refs.cmpGestioneCamereStoricoList.loadDataLettiStorico(me.idLetto);
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
    },
};
</script>

<style></style>
